export default "__VITE_PUBLIC_ASSET__165e5db4__"